import { cn } from '@global/utils/styling';
import './style.scss';

export interface CommonSelectProps {
  value?: string;
  className?: string;
  label?: string;
  name?: string;
  icon?: React.ReactNode;
  error?: boolean;
  isValid?: boolean;
  errorMessage?: string;
  children?: React.ReactNode;
  id?: string;
  size?: number;
  disabled?: boolean;
  options?: unknown[];
  itemValue?: string;
  itemLabel?: string;
  itemId?: string;
  defaultOption?: string;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const CommonSelect = (props: CommonSelectProps) => {
  return (
    <>
      <div
        className={cn('common-select', [
          props.className || '',
          props.disabled && 'common-select--disabled',
        ])}
      >
        {props.label && (
          <label
            htmlFor={props.id}
            className="common-select__label text-subtitle-2"
          >
            {props.label}
          </label>
        )}
        <select
          disabled={props.disabled}
          onChange={props.onChange}
          id={props.id}
          name={props.name}
          className={cn({
            error: props.error,
            valid: props.isValid,
          })}
          value={props.value}
        >
          {props.placeholder && (
            <option value="" disabled hidden>
              {props.placeholder}
            </option>
          )}
          {props.defaultOption && (
            <option value="" key={props.defaultOption}>
              {props.defaultOption}
            </option>
          )}
          {props.options?.map((option) => (
            <option key={option[props.itemId]} value={option[props.itemValue]}>
              {option[props.itemLabel]}
            </option>
          ))}
        </select>
        {props.error && props.errorMessage && (
          <p className="common-select__error-message text-subtitle-2">
            {props.errorMessage}
          </p>
        )}
      </div>
    </>
  );
};
